<template>
    <v-layout row wrap xs12>
        <v-flex xs3>
            <v-select
                    :items="specialities"
                    v-model="form.speciality"
                    item-text="nameUk"
                    item-value="id"
                    return-object
                    label="Спеціальність"
            ></v-select>
        </v-flex>
        <v-flex xs3>
            <v-select
                    :items="faculties"
                    v-model="form.faculty"
                    item-text="nameUk"
                    item-value="id"
                    return-object
                    label="Факультет"
                    :disabled="form.speciality === null"
            ></v-select>
        </v-flex>
        <v-flex xs3>
            <v-select
                    :items="finalExamNames"
                    v-model="form.finalExamName"
                    item-text="name"
                    item-value="id"
                    return-object
                    label="Назва іспиту"
                    :disabled="form.faculty === null"
            ></v-select>
        </v-flex>
        <v-flex xs3>
            <v-select
                    :items="finalExamDates"
                    v-model="form.finalExamDate"
                    item-text="date"
                    item-value="id"
                    return-object
                    label="Дата іспиту"
                    :disabled="form.finalExamName === null"
            ></v-select>
        </v-flex>
        <v-flex xs12>
            <v-btn :disabled="form.finalExamDate === null" @click="printDialog = true">
                <v-icon class="mr-2">print</v-icon>Роздрукувати денний протокол</v-btn>
        </v-flex>

        <v-dialog v-model="printDialog" max-width="1300px">
            <print-daily-protocol
                    v-if="printDialog"
                    :faculty-id="form.faculty.id"
                    :speciality-id="form.speciality.id"
                    :final-exam-name-id="form.finalExamName.id"
                    :final-exam-date="form.finalExamDate"
                    @close="printDialog = false"
            ></print-daily-protocol>
        </v-dialog>
    </v-layout>
</template>
<script>
    import HttpService from "../../../../HttpService";
    import {formatShortDate} from "../../../../helpers/dateHelper";
    import PrintDailyProtocol from "./PrintDailyProtocol";

    export default {
        components: {
          PrintDailyProtocol  
        },
        data: () => ({
            specialities: [],
            faculties: [],
            finalExamNames: [],
            finalExamDates: [],

            form: {
                speciality: null,
                faculty: null,
                finalExamName: null,
                finalExamDate: null,
            },
            formatShortDate,

            printDialog: false,
        }),
        watch: {
            "form.speciality": function (newSpec, oldSpec) {
                if (newSpec !== null) {
                    HttpService.getInstance()
                        .get(`faculties/getAllBySpeciality/${newSpec.id}`)
                        .then(resp => {
                            this.faculties = resp;
                        })
                }
            },
            "form.faculty": function (newFac, oldFac) {
                if (newFac !== null) {
                    HttpService.getInstance()
                        .get(`FinalExamAdmin/getFinalExamNames/${this.form.speciality.id}`)
                        .then(resp => {
                            this.finalExamNames = resp;
                        })
                }
            },
            "form.finalExamName": function (newExam, oldExam) {
                if (newExam !== null) {
                    HttpService.getInstance()
                        .get(`FinalExamAdmin/getFinalExamDatesByExam/${newExam.id}`)
                        .then(resp => {
                            this.finalExamDates = resp.map(r => formatShortDate(r));
                        })
                }
            }
        },
        mounted() {
            HttpService.getInstance()
                .get("specialities/getAllWithFinalExam")
                .then(resp => {
                    this.specialities = resp;
                })
        }
    }
</script>